import { useState } from "react";
import { Button } from "../ui/button";
import { LifeBuoy, Loader2 } from "lucide-react";
import api from "../../lib/api";

export default function AdminAssistPassengerButton({ user }) {
  const [loading, setLoading] = useState(false);
  if (user?.role !== "passenger") return null;

  const open = async () => {
    if (!window.confirm(`Ouvrir une session d'assistance (60 min, espèces uniquement) sur le compte de ${user.name} (${user.email}) dans un nouvel onglet ?`)) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/admin/users/${user.id}/impersonate`);
      const url = new URL(window.location.origin + "/impersonate");
      url.searchParams.set("t", data.token);
      url.searchParams.set("name", user.name || "");
      window.open(url.toString(), "_blank");
    } catch (e) {
      alert(e.response?.data?.detail || "Impossible d'ouvrir la session d'assistance");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button size="sm" variant="outline" onClick={open} disabled={loading}
      className="text-xs border-[#DC2626] text-[#DC2626] hover:bg-[#DC2626]/10 h-7"
      data-testid={`assist-passenger-${user.id}`} title="Se connecter en tant que ce passager pour l'assister">
      {loading ? <Loader2 className="w-3 h-3 mr-0.5 animate-spin" /> : <LifeBuoy className="w-3 h-3 mr-0.5" />} Assister
    </Button>
  );
}
